import { Button, Icon, Menu, Portal, Separator } from "@chakra-ui/react";
import { CaretDownIcon } from "@phosphor-icons/react/dist/ssr";

const ORDER_OPTIONS = [
    { value: "ASC", label: "Precio (menor a mayor)" },
    { value: "DESC", label: "Precio (mayor a menor)" },
];

const findOption = (orderValue) => ORDER_OPTIONS.find((opt) => opt.value === orderValue) || null;

const OrderMenu = ({ state, setFilter, clearFilter }) => {
    const onPick = (value) => {
        if (!value) clearFilter("order");
        else setFilter("order", value);
    };

    const active = findOption(state.order);
    const isActive = !!active;
    const triggerLabel = active?.label || "Ordenar";

    return (
        <Menu.Root>
            <Menu.Trigger asChild>
                <Button
                    h="36px"
                    px={4}
                    fontSize="sm"
                    fontWeight={500}
                    bg={isActive ? "colorPalette.solid" : "white"}
                    color={isActive ? "white" : "gray.700"}
                    borderWidth="1px"
                    borderColor={isActive ? "colorPalette.solid" : "gray.200"}
                    borderRadius="md"
                    _hover={{ bg: isActive ? "colorPalette.solid" : "gray.50" }}
                >
                    {triggerLabel}
                    <Icon ml={2} boxSize={3} opacity={0.7}>
                        <CaretDownIcon weight="bold" />
                    </Icon>
                </Button>
            </Menu.Trigger>
            <Portal>
                <Menu.Positioner>
                    <Menu.Content colorPalette="accent" shadow="lg" minW="240px" py={2}>
                        <Menu.Item
                            value="__none"
                            onClick={() => onPick(null)}
                            fontSize="sm"
                            p={2}
                            color={isActive ? "gray.700" : "gray.400"}
                        >
                            Sin orden
                        </Menu.Item>
                        <Separator my={1} />
                        {ORDER_OPTIONS.map(({ value, label }) => (
                            <Menu.Item
                                key={value}
                                value={value}
                                onClick={() => onPick(value)}
                                fontSize="sm"
                                p={2}
                            >
                                {label}
                            </Menu.Item>
                        ))}
                    </Menu.Content>
                </Menu.Positioner>
            </Portal>
        </Menu.Root>
    );
};

export default OrderMenu;
